export default function SettingsPage() {
  return null;
}